import { isNetworkFailure } from "../loginRum";
import { mapCognitoError } from "./mapCognitoError";

function extractAxiosCode(error: unknown): string | undefined {
  if (!error || typeof error !== "object") {
    return undefined;
  }
  const { code } = error as { code?: unknown };
  return typeof code === "string" && code.length > 0 ? code : undefined;
}

function appendCode(message: string, error: unknown): string {
  const code = extractAxiosCode(error);
  return code ? `${message} (code: ${code})` : message;
}

interface FormatSessionInitErrorOptions {
  networkFailureMessage: string;
  defaultMessage: string;
}

export function formatSessionInitErrorMessage(
  error: unknown,
  options: FormatSessionInitErrorOptions
): string {
  if (isNetworkFailure(error)) {
    return appendCode(options.networkFailureMessage, error);
  }

  const mapped = mapCognitoError(error);
  if (mapped.code !== "auth/unknown") {
    return mapped.message;
  }

  return appendCode(options.defaultMessage, error);
}
